import { render, staticRenderFns } from "./AttestationsEdit.vue?vue&type=template&id=806051b0&scoped=true&"
import script from "./AttestationsEdit.vue?vue&type=script&lang=js&"
export * from "./AttestationsEdit.vue?vue&type=script&lang=js&"
import style0 from "./AttestationsEdit.vue?vue&type=style&index=0&id=806051b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806051b0",
  null
  
)

export default component.exports